import GlobalMixin from '@/app/shared/mixins/global';
import ManageStoreMixin from './ManageStoreMixin';
import { apiConstants } from '../config';

export default {
    mixins: [
        GlobalMixin,
        ManageStoreMixin,
    ],
    data() {
        return {
            pageID: null,
        }
    },
    computed: {
        moduleInternalCode() {
            return apiConstants.code;
        },
        moduleCode() {
            return this.moduleInternalCode;
        },
        acl(){
            return this.$store.getters[`${this.moduleCode}/getAcl`](this.pageID);
        },
        url(){
            return this.$store.getters[`${this.moduleCode}/getUrl`](this.pageID);
        },
        canChangeState() {
            return this.acl && this.acl.state ? this.$auth.check(this.acl.state) : false;
        },
        canChangeRole() {
            return this.acl && this.acl.role ? this.$auth.check(this.acl.role) : false;
        },
        canShowResources() {
            return this.acl && this.acl.resources ? this.$auth.check(this.acl.resources) : false;
        },
        canImportResources() {
            return this.acl && this.acl.harvest ? this.$auth.check(this.acl.harvest) : false;
        },
    }
};